import { render, staticRenderFns } from "./CustomFieldsInfoTextComponent.vue?vue&type=template&id=66a32733&scoped=true"
import script from "./CustomFieldsInfoTextComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomFieldsInfoTextComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomFieldsInfoTextComponent.vue?vue&type=style&index=0&id=66a32733&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a32733",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a32733')) {
      api.createRecord('66a32733', component.options)
    } else {
      api.reload('66a32733', component.options)
    }
    module.hot.accept("./CustomFieldsInfoTextComponent.vue?vue&type=template&id=66a32733&scoped=true", function () {
      api.rerender('66a32733', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/CustomFieldsInfoText/CustomFieldsInfoTextComponent.vue"
export default component.exports